import script from "./AppStoreView.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppStoreView.vue?vue&type=script&lang=ts&setup=true"

import "./AppStoreView.vue?vue&type=style&index=0&id=c7eb9b34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7eb9b34"]])

export default __exports__